/**
 * @file toast组件 显示倒计时
 * @author jianghaoran01
 */
import React, { useState, useEffect } from 'react';
import { useInterval } from 'ahooks';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import NotificationApi from './base';
import ConfigProvider, { globalConfig, defaultPrefixCls as providerDefaultPrefixCls } from '../config-provider';
const { getPrefixCls } = globalConfig();
const PREFIX = 'notification-hastime';
const TOST_CLS_PREFIX = '-notification-toast-wrap';
let defaultPrefixCls = providerDefaultPrefixCls;
let maxToastArrLength = 4; // 最多显示多少个toast
/**
 * 代理对象
 * 使用时: target.xxx会全部丢给notification 类似notification.xxx
 */
const target = {};
const toastArr = [];
const paramIgnoreFun = ['destroy'];
// 向数组尾部添加一个元素
function addToastKey(key) {
    toastArr.push(key);
}
// 弹出数组头部元素
function unshiftToast() {
    return toastArr.splice(0, 1)[0];
}
// 移除数组元素
function removeToastKey(key) {
    for (let i = 0; i < toastArr.length; i++) {
        if (key === toastArr[i]) {
            toastArr.splice(i, 1);
            break;
        }
    }
}
const ToastDom = props => {
    const { message = '', description, countdown, notificationKey, onClose = null, prefixCls: customizePrefixCls } = props;
    const [counter, setCounter] = useState(countdown);
    // const prefixCls = getPrefixCls('toast-wrap', '');
    const prefixCls = getPrefixCls('', customizePrefixCls || defaultPrefixCls) + TOST_CLS_PREFIX;
    const clear = useInterval(() => {
        counter > 0 && setCounter(counter - 1);
    }, 1000);
    useEffect(() => {
        if (counter <= 0) {
            removeToastKey(notificationKey);
            NotificationApi.destroy(notificationKey);
            onClose && onClose();
            clear();
        }
    }, [counter]);
    // useEffect(() => {
    //     return () => {
    //         clearTimeout(timerID);
    //     }
    // }, []);
    return (<div className={getPrefixCls('', customizePrefixCls || defaultPrefixCls)
            + TOST_CLS_PREFIX}>
            <div className={classNames(`${getPrefixCls('', customizePrefixCls || defaultPrefixCls)}${TOST_CLS_PREFIX}-left`, { [prefixCls + '-no-description']: !description })}>
                {message instanceof Error ? message.toString() : message}
            </div>
            {counter === undefined ? null : (<div className={getPrefixCls('', customizePrefixCls || defaultPrefixCls)
                + TOST_CLS_PREFIX
                + '-right'}>
                    ({counter}
                    <span>s</span>)
                </div>)}
        </div>);
};
function DescriptionDom(props) {
    const { description } = props;
    return description ? <div className="description-wrap">{description}</div> : null;
}
let handler = {
    get: (...args) => {
        const name = args[1];
        // 关闭、删除提示可以根据用户传参直接调用，避免key错赋值
        if (paramIgnoreFun.includes(name)) {
            return props => Reflect.get(NotificationApi, name)(props);
        }
        // let key = new Date().getTime() + ''; // 通过key来强制关闭notification
        // const key = Symbol('key');
        // let key = Math.random();
        const key = uniqueId();
        return props => {
            // 定义默认图标
            const iconProps = {
                icon: null,
            };
            const args = Object.assign(Object.assign({ key, type: 'info', autoClose: true }, iconProps), props);
            // 设置最大显示数
            if (name === 'config' && props.maxCount) {
                maxToastArrLength = props.maxCount;
            }
            // 设置prefixcls 兼容antd
            // 升级rc-notificon5后通过ConfigProvider.config来配置prefixcls
            if (name === 'config' && props.prefixCls) {
                defaultPrefixCls = props.prefixCls;
                ConfigProvider.config({ prefixCls: props.prefixCls });
            }
            // key相同时不重新渲染
            if (!~toastArr.indexOf(args.key)) {
                // autoClose不为true时，不添加到toastArr，即不受maxCount限制
                if (args.autoClose) {
                    addToastKey(args.key);
                }
                if (toastArr.length > maxToastArrLength) {
                    NotificationApi.destroy(unshiftToast());
                }
            }
            // 初始化倒计时
            // let tempDuration;
            // if (!args.duration) {
            //     tempDuration = 0;
            // }
            // else {
            //     tempDuration = args.duration;
            // }
            let tempDuration = args.duration;
            args.duration = 0;
            // 设置样式 有描述和没描述间距不一样
            let tempClassName = (props === null || props === void 0 ? void 0 : props.className) + ' ' + PREFIX;
            if (args.description) {
                tempClassName
                    += ' '
                        + getPrefixCls('', (props === null || props === void 0 ? void 0 : props.prefixCls) || defaultPrefixCls)
                        + '-notification-has-description';
            }
            if (props && props.className) {
                args.className = props.className + ' ' + tempClassName;
            }
            else {
                args.className = tempClassName;
            }
            // 设置DOM
            args.message = (<ToastDom message={args.message} description={args.description} countdown={args.autoClose ? tempDuration : undefined} // 同时设置了duration和autoClose，优先使用autoClose
             notificationKey={args.key} onClose={props === null || props === void 0 ? void 0 : props.onClose} prefixCls={props === null || props === void 0 ? void 0 : props.prefixCls}/>);
            args.description = (<DescriptionDom description={args.description}/>);
            return Reflect.get(NotificationApi, name)(args);
        };
    }
};
const toast = new Proxy(target, handler);
export default toast;
